import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {GameIntroController, IGameIntroView} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroController";
import {GameIntroView, IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {PerformanceLogger} from "@nolimitcity/slot-game/bin/dev/performancelogger/PerformanceLogger";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {EdisonBackground} from "./background/EdisonBackground";
import {EdisonFontConfig} from "./EdisonFontConfig";
import {EdisonGameAssets} from "./EdisonGameAssets";
import {EdisonGameConfig} from "./EdisonGameConfig";
import {EdisonSoundConfig} from "./EdisonSoundConfig";
import {EdisonFeatureController} from "./features/EdisonFeatureController";
import {EdisonFreespinController} from "./features/freespin/EdisonFreespinController";
import {EdisonFreespinOverlay} from "./features/freespin/EdisonFreespinOverlay";
import {EdisonFreespinIntroController} from "./features/freespin/freespinIntro/EdisonFreespinIntroController";
import {EdisonFreespinIntroView} from "./features/freespin/freespinIntro/EdisonFreespinIntroView";
import {EdisonFreespinOutroController} from "./features/freespin/freespinOutro/EdisonFreespinOutroController";
import {EdisonFreespinOutroView} from "./features/freespin/freespinOutro/EdisonFreespinOutroView";
import {EdisonRandomFeatureController} from "./features/randomFeature/EdisonRandomFeatureController";
import {EdisonRandomFeatureIntro} from "./features/randomFeature/EdisonRandomFeatureIntro";
import {EdisonRespinController} from "./features/respin/EdisonRespinController";
import {EdisonRespinIntroController} from "./features/respin/EdisonRespinIntroController";
import {EdisonRespinIntroView} from "./features/respin/EdisonRespinIntroView";
import {EdisonRespinOverlay} from "./features/respin/EdisonRespinOverlay";
import {EdisonAnticipationOverlay} from "./foreground/EdisonAnticipationOverlay";
import {EdisonLogoView} from "./foreground/EdisonLogoView";
import {EdisonScatterOverlay} from "./foreground/EdisonScatterOverlay";
import {EdisonWinWaysSign} from "./foreground/EdisonWinWaysSign";
import {EdisonIntroView} from "./intro/EdisonIntroView";
import {EdisonReelAreaView} from "./reel/EdisonReelAreaView";
import {EdisonReelController} from "./reel/EdisonReelController";
import {EdisonReels} from "./reel/EdisonReels";
import {EdisonReelSymbolStateCreator} from "./reel/reelSymbol/EdisonReelSymbolStateCreator";
import {EdisonStateReelSymbol} from "./reel/reelSymbol/EdisonStateReelSymbol";
import {EdisonSymbolController} from "./reel/reelSymbol/EdisonSymbolController";
import {EdisonReelStopPresentationController} from "./reelStopPresentation/EdisonReelStopPresentationController";
import {EdisonParsedGameData} from "./server/data/EdisonParsedGameData";
import {EdisonParsedInitData} from "./server/data/EdisonParsedInitData";
import {EdisonServerDataParser} from "./server/EdisonServerDataParser";
import {EdisonSpinController} from "./spin/EdisonSpinController";
import {EdisonBigWinController} from "./winpresentation/bigwin/EdisonBigWinController";
import {EdisonWPView} from "./winpresentation/EdisonWPView";
import {EdisonExtraSpinController} from "./winpresentation/extraSpin/EdisonExtraSpinController";
import {EdisonIndividualWPController} from "./winpresentation/individual/EdisonIndividualWPController";
import {EdisonIndividualWPView} from "./winpresentation/individual/EdisonIndividualWPView";
import {EdisonInitialWPController} from "./winpresentation/initial/EdisonInitialWPController";
import {EdisonFreespinZeroBetController} from "./zeroBet/EdisonFreespinZeroBetController";
import {EdisonRespinZeroBetController} from "./zeroBet/EdisonRespinZeroBetController";
import {IndiSymWinHighlightPresentation} from "./winpresentation/IndiSymWinHighlightPresentation";

/**
 * Created by Alican Köker on 2019-03-04.
 */

export class EdisonGameModuleConfig implements IGameModuleConfig {

    public static instance:EdisonGameModuleConfig = new EdisonGameModuleConfig();

    private static gameTweakerTest:GameTweakerTest;
    private static performanceLogger:PerformanceLogger;
    public static background:EdisonBackground;

    //public
    public static featureController:EdisonFeatureController;
    public static randomFeatureIntro:EdisonRandomFeatureIntro;
    public static symbolController:EdisonSymbolController;
    public static randomFeatureController:EdisonRandomFeatureController;
    public static freespinController:EdisonFreespinController;
    public static respinController:EdisonRespinController;
    public static freespinOverlay:EdisonFreespinOverlay;
    public static respinOverlay:EdisonRespinOverlay;
    public static individualWPView:EdisonIndividualWPView;
    public static logoView:EdisonLogoView;
    public static scatterOverlay:EdisonScatterOverlay;
    public static winWaysSign:EdisonWinWaysSign;
    public static winPresentationView:EdisonWPView;
    public static anticipationView:EdisonAnticipationOverlay;

    GAME_CONFIG:IGameConfig = EdisonGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = EdisonSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = EdisonFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = EdisonGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new EdisonServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new EdisonParsedInitData(data, <EdisonServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new EdisonParsedGameData(data, <EdisonServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new EdisonSpinController();

    REELS:() => Reels = () => new EdisonReels();

    REEL_AREA_VIEW:() => ReelAreaView = () => new EdisonReelAreaView();

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new EdisonReelController(reelId);

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.
    // REEL_PART_ANIMATOR?:(callbacks:ReelPartAnimatorCallbacks) => ReelPartAnimator; // Default new ReelPartAnimator.

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):EdisonStateReelSymbol => {
            return new EdisonStateReelSymbol(symName, reelId, state);
        });
    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new EdisonReelSymbolStateCreator();

    INTRO_VIEW:(onClickCallback:() => void) => EdisonIntroView =
        (onClickCallback:() => void) => new EdisonIntroView({
            layer : EdisonGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : EdisonGameAssets.MAIN_GAME_BACKGROUND},
                mobile : {landscape : EdisonGameAssets.INTRO_BACKGROUND},
            },
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_HIGH]
            },
            mobileScale : 1.2,
            portraitScale : 1.7
        });

    SCREENS:(() => ScreenController)[] = [
        () => new EdisonFreespinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new EdisonFreespinIntroView({
                    layer : EdisonGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1
                }, false);
            },
            autoCloseTime : 20
        }),
        () => new EdisonFreespinOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new EdisonFreespinOutroView({
                    layer : EdisonGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1
                }, false);
            },
            autoCloseTime : 20
        }),
        () => new EdisonRespinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new EdisonRespinIntroView({
                    layer : EdisonGameConfig.instance.LAYERS.RESPIN_INTRO_TEXT_OVERLAY.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    }
                }, false);
            },
            autoCloseTime : 20
        })
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new EdisonFreespinZeroBetController(),
        () => new EdisonRespinZeroBetController()
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new IndiSymWinHighlightPresentation(indexes)],
            [
            indexes => new EdisonBigWinController(indexes),
            indexes => new EdisonInitialWPController(indexes)
        ],
        [indexes => new EdisonExtraSpinController(indexes)]
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new EdisonReelStopPresentationController(index)
    ];


    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new EdisonIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    //INTRO_CONTROLLER?:(viewCreator:(onClickCallback:() => void) => GameIntroView) => GameIntroController;

    GAME_FEATURE_CREATOR:() => void = () => {
        EdisonGameModuleConfig.gameTweakerTest = new GameTweakerTest();
        EdisonGameModuleConfig.performanceLogger = new PerformanceLogger();

        EdisonGameModuleConfig.background = new EdisonBackground({
            layer : GameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {
                    image : EdisonGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(0, 0)
                },
                FREESPIN : {
                    image : EdisonGameAssets.FREESPIN_BACKGROUND, offset : new PIXI.Point(0, 0)
                },
                STACKED_RESPIN : {
                    image : EdisonGameAssets.FREESPIN_BACKGROUND, offset : new PIXI.Point(0, 0)
                }
            },
            stretch : false
        });

        EdisonGameModuleConfig.featureController = new EdisonFeatureController();
        EdisonGameModuleConfig.randomFeatureIntro = new EdisonRandomFeatureIntro();
        EdisonGameModuleConfig.symbolController = new EdisonSymbolController();
        EdisonGameModuleConfig.randomFeatureController = new EdisonRandomFeatureController();
        EdisonGameModuleConfig.freespinOverlay = new EdisonFreespinOverlay();
        EdisonGameModuleConfig.freespinController = new EdisonFreespinController();
        EdisonGameModuleConfig.respinController = new EdisonRespinController();
        EdisonGameModuleConfig.respinOverlay = new EdisonRespinOverlay();
        EdisonGameModuleConfig.individualWPView = new EdisonIndividualWPView();
        EdisonGameModuleConfig.logoView = new EdisonLogoView();
        EdisonGameModuleConfig.scatterOverlay = new EdisonScatterOverlay();
        EdisonGameModuleConfig.winWaysSign = new EdisonWinWaysSign();
        EdisonGameModuleConfig.winPresentationView = new EdisonWPView();
        EdisonGameModuleConfig.anticipationView = new EdisonAnticipationOverlay();

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(EdisonGameModuleConfig.instance) {
            throw new Error("EdisonGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}